'use client'

// Next Imports
import { useReportWebVitals } from 'next/web-vitals'

/**
 * Фронтовый датчик web-vitals (LCP/INP/CLS/TTFB/FCP/FID) за клиентским флагом.
 *
 * Без видимого UI (`return null`) — узкая client-граница, монтируется ровно одной
 * строкой в `<body>` root layout (НЕ в Providers). Гейт — КЛИЕНТСКИЙ флаг
 * `NEXT_PUBLIC_PERF_OBSERVABILITY` (префикс `NEXT_PUBLIC_` обязателен, иначе в
 * браузере `undefined` и метрики молча не пишутся). OFF по умолчанию.
 *
 * Для baseline репорт идёт ТОЛЬКО в browser console (снимается из Playwright
 * `page.on('console')`) — без серверного endpoint/beacon (T-27-VITALS: нет
 * открытого приёмника).
 */
export function WebVitals() {
  useReportWebVitals(metric => {
    if (process.env.NEXT_PUBLIC_PERF_OBSERVABILITY !== 'true') return

    // eslint-disable-next-line no-console -- намеренный baseline-репорт без серверного приёмника (T-27-VITALS)
    console.log(`[web-vital] ${metric.name} ${Math.round(metric.value)} id=${metric.id}`)
  })

  return null
}
